<template>
  <img :src="icon" :class="props.class ?? undefined" :alt>
</template>
<script setup lang="ts">
import type { AllowedComponentProps } from 'vue'

const props = withDefaults(
  defineProps<{
    /** Volitelné: volající renderuje IconViewer až pod `v-if`, když ikonu má. */
    iconPromise?: () => Promise<typeof import('*?inline')>
    class?: AllowedComponentProps['class']
    alt?: string
  }>(),
  { class: () => 'size-[25px] object-contain', alt: 'Icon', iconPromise: undefined }
)

const icon = shallowRef<string>()

const loadIcon = async () => {
  if (!props.iconPromise) return
  const base64 = await props.iconPromise()
  icon.value = base64.default
}

onServerPrefetch(loadIcon)

watch(
  () => props.iconPromise,
  async () => {
    loadIcon()
  },
  { immediate: true }
)
</script>
